<template>
  <div class="modal-window organization_wrap krs037">
    <header class="modal-header">
        <div class="tit">{{ modalInfo.title }}</div>
        <button @click="handleClose" class="btn_close">X</button>
    </header>

    <div class="modal-content">
      <div class="clear">
        <div class="organization-area">
          <div class="tab_ty2" id="tabs">
            <ul class="tab-menu">
              <!-- <li v-show="inOutKbn === 'IN'" class="active"> -->
              <li v-bind:class="{ active: currentTab === 0 }">
                <button type="button" @click="changeView(0)">{{$i18nUtil.trans("message.MultiOrg.001","조직도")}}</button>
              </li>
              <!-- <li v-show="inOutKbn === 'OUT'"> -->
              <li v-show="isInviteUse" v-bind:class="{ active: currentTab === 1 }">
                <button type="button" @click="changeView(1)">{{$i18nUtil.trans("message.MultiOrg.002","그룹사")}}</button>
              </li>
              <!-- <li v-show="inOutKbn === 'OUT'"> -->
              <li v-show="isInviteUse" v-bind:class="{ active: currentTab === 2 }">
                <button type="button" @click="changeView(2)">{{$i18nUtil.trans("message.MultiOrg.003","협력업체")}}</button>
              </li>
            </ul>
            <div class="tab-content">
              <div v-show="currentTab == 0">
                <InOrg
                  ref="org"
                  @openNode="openNode"
                  @selectNode="selectNode"
                  @deSelectNode="deSelectNode"
                  @selectUser="selectUser"
                  @deSelectUser="deSelectUser"
                />
              </div>
              <div v-show="currentTab == 1 && isInviteUse">
                <GroupOrg
                  ref="groupOrg"
                  @openNode="openNode"
                  @selectNode="selectNode"
                  @deSelectNode="deSelectNode"
                  @selectUser="selectUser"
                  @deSelectUser="deSelectUser"
                />
              </div>
              <div v-show="currentTab == 2 && isInviteUse">
                <PartnerOrg ref="partnerOrg" @selectUser="selectUser" @deSelectUser="deSelectUser" />
              </div>
            </div>
          </div>
        </div>

        <div class="btn-area">
            <button class="btn-primary-smaller black" @click="handleAddItems">{{$i18nUtil.trans("button.add","추가")}}</button>
            <button class="btn-primary-smaller" :class="$i18nUtil.getLanguage() === 'en'? 'enCss' : ''" @click="handleRemoveItems">{{$i18nUtil.trans("button.delete","삭제")}}</button>
        </div>

        <div class="selected-area">
          <dl>
              <dt><input type="checkbox" id="checkAll" @click="checkAll($event)"><label for="checkAll" >{{$i18nUtil.trans("message.MultiOrg.004","삭제선택")}}</label></dt>
              <dd>
                  <ul>
                    <li v-for="(user, index) in selectedUsers" :key="'user_' + index">
                        <input type="checkbox" :value="user" :id="'user_' + user.userId" v-model="outPutUsers" />
                        <label :for="'user_' + user.userId">{{ user.userName }} ( {{ user.deptName }} )</label>
                    </li>
                  </ul>
              </dd>
          </dl>
        </div>
      </div>
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn-primary" style="border:1px solid #000;" @click="handleClose">{{$i18nUtil.trans("button.cancel","취소")}}</button>
      <button type="button" class="btn_ty1" @click="returnOrgParams">{{$i18nUtil.trans("button.confirm","확인")}}</button>
    </footer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import InOrg from "@/components/cowork/common/organization/org/InOrg";
import GroupOrg from "@/components/cowork/common/organization/org/GroupOrg";
import PartnerOrg from "@/components/cowork/common/organization/org/PartnerOrg";
export default {
  name: "tabs",
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {
    InOrg,
    GroupOrg,
    PartnerOrg,
  },
  data() {
    return {
      currentTab: 0,
      tabs: ["조직도", "그룹사", "협력업체"],
      /* Tree options */
      value: null,
      alwaysOpen: true,
      multipleYn: true,
      openOnClick: true,
      parentNodeId: null,

      /* checked User & Dept */
      allCheck: [],
      checkUsers: [],
      outPutUsers: [],
      checkDepts: [],
      outPutDepts: [],
      target : null,
      /* 내/외부망 구분자 */
      inOutKbn : null,
      /* Rest */
      url: null,
      method: null,
      req: {
        companyId: null,
        deptId: null,
        parentDeptId: null,
      },
      isInviteUse : null
    };
  },
  mounted() {
    this.getInOutCheck();
    //권한그룹별사용자설정에서 MultiOrg 호출 시 mode="ROLE_USER"
    //INCLUDE/EXCLUDE 관리에서 호출 시 mode="ORG_PAPER_DEPT_USER"
    if(this.modalInfo.mode !== "ROLE_USER" || this.modalInfo.mode !== "ORG_PAPER_DEPT_USER"){
      this.checkInviteUse();
    }
  },
  computed: {
    ...mapState("tree", ["treeData"]),
    ...mapState("tree", ["userList"]),
    ...mapState("tree", ["selectedUsers"]),
    ...mapState("tree", ["selectedDepts"]),
  },
  methods: {
    /* rest Call&CallBack Action */
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* treeList setting */
    ...mapActions("tree", ["addUser"]),
    ...mapActions("tree", ["addDept"]),
    ...mapActions("tree", ["setOrgTree"]),
    ...mapMutations("tree", ["resetTreeList"]),
    ...mapMutations("tree", ["setTreeOfUserList"]),
    ...mapMutations("tree", ["setSelectedUsers"]),
    ...mapMutations("tree", ["setSelectedDepts"]),
    ...mapActions("tree", ["removeUser"]),
    ...mapActions("tree", ["removeDept"]),
    ...mapActions("modals", ["showDialog"]),
    /* 
      TODO.
        내/외부망 구분자 값 받아와 조직도 탭 노출 결정.
        내부망(조직도) / 외부망(그룹사/협력업체)
     */
    getInOutCheck() {
      let obj = this;
      let reqData = {
        url : "/api/auth/inOutCheck",
        method : "post"
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          obj.inOutKbn = res;
          if(obj.inOutKbn === 'IN') {
            obj.changeView(0);
          } else {
            // obj.changeView(1);
            // 2021-11-17 내/외부망 구분없이 default [조직도]
            obj.changeView(0);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    checkInviteUse() {
      let obj = this;
      let reqData = {
        url : "/api/auth/checkInviteUse",
        method : "post"
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function (res) {
        if(res !== null) {
          obj.isInviteUse = res;
        }
      })
      .catch(function (err) {
        console.log(err);
      });
    },
    /* 탭 변경 */
    async changeView(index) {
      this.resetTreeList(null);
      this.setSelectedUsers(null);
      this.setSelectedDepts(null);
      this.setTreeOfUserList(null);
      this.$refs.org.value = [];
      this.$refs.org.checkUsers = [];
      this.$refs.groupOrg.value = [];
      this.$refs.groupOrg.checkUsers = [];
      if (index === 0) {
        /* 조직도 */
        await this.$refs.org.getTreeData();
      } else if (index === 1) {
        /* 그룹사 */
        await this.$refs.groupOrg.getCompanyList();
      } else if (index === 2) {
        /* 협력업체 */
        await this.$refs.partnerOrg.getPartnerList();
        if(document.getElementsByClassName("vue-treeselect__list")[0] !== undefined) {
          document.getElementsByClassName("vue-treeselect__list")[0].firstChild.classList.toggle('show');
        }
      }
      this.currentTab = index;
    },
    /* async openNode({ action, parentNode, callback }) { */
    async openNode(param) {
        let obj = this;
        let reqData = {};
        reqData.url = obj.modalInfo.url;
        reqData.method = obj.modalInfo.method;
        reqData.params = {
          parentDeptId: param.parentNode.id,
          companyId: param.companyId,
        };
        await this.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (data) {
            /* treeData set */
            let rootNode = data.result.companyInfo;
            let treeList = data.result.treeList;
            obj.setOrgTree({ treeList: treeList, parentNode: param.parentNode });
          })
          .catch(function (err) {
            console.log(err);
          });
    },
    selectNode(param) {
      /* 선택된 부서 목록 push */
//      this.checkDepts.push(param.node);
      let obj = this;
      let reqData = {
        url : "/api/org/getUserList",
        method : "post",
        params : {
          deptId : param.node.id
        }
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if(res.errorCode !== null) {
            let errorCode = res.errorCode;
          } else {
            obj.setTreeOfUserList(res.result);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    deSelectNode(param) {
      //부서 선택 임시 보류.
      //let checkDepts = this.checkDepts;
      // checkDepts = checkDepts.filter(function (item) {
      //   return item.id !== param.node.id;
      // });
      // this.checkDepts = checkDepts;
    },
    selectUser(param) {
      this.target = param.target;
      if(param.type === "ALL") {
        this.checkUsers = param.data;
      } else {
        this.checkUsers.push(param.data);
      }
    },
    deSelectUser(user) {
      let checkUsers = this.checkUsers;
      if(user.type === "ALL") {
        this.checkUsers = [];
      } else {
        checkUsers = checkUsers.filter(function (item) {
        return item.userId !== user.data.userId;
        });
        this.checkUsers = checkUsers;
      }
    },
    /* 추가 버튼 클릭 시 */
    handleAddItems() {
      let checkUsers = this.checkUsers;
      let checkDepts = this.checkDepts;

      if (checkUsers.length > 0 || checkDepts.length > 0) {
        if (checkUsers.length > 0) {
          this.addUser({
            addkUsers: checkUsers,
            selectedUsers: this.selectedUsers,
          });
        }
        if (checkDepts.length > 0) {
          this.addDept({
            addDepts: checkDepts,
            selectedDepts: this.selectedDepts,
          });
        }
      } else {
        alert("멤버로 추가할 대상을 조직도에서 선택해주세요.");
      }
      if(this.target != null && this.target != undefined) {
        document.getElementById(this.target).checked = false;
      }
      this.$refs.org.value = [];
      this.$refs.org.checkUsers = [];
      this.$refs.groupOrg.value = [];
      this.$refs.groupOrg.checkUsers = [];
      this.$refs.partnerOrg.value = [];
      this.$refs.partnerOrg.checkUsers = [];
      this.checkDepts = [];
      this.checkUsers = [];
    },
    /* 삭제 버튼 클릭 시 */
    handleRemoveItems() {
      let outPutUsers = this.outPutUsers;
      let outPutDepts = this.outPutDepts;
      if (outPutUsers.length > 0 || outPutDepts.length > 0) {
        if (outPutUsers.length > 0) {
          this.removeUser({
            removeUsers: outPutUsers,
            selectedUsers: this.selectedUsers,
          });
          this.outPutUsers = [];
          if(document.getElementById("checkAll").checked !== false) {
            document.getElementById("checkAll").checked = false;
          }
        }
        if (outPutDepts.length > 0) {
          this.removeDept({
            removeDepts: outPutDepts,
            selectedDepts: this.selectedDepts,
          });
          this.outPutDepts = [];
        }
      } else {
        alert("제거할 대상이 없습니다.");
      }
    },
    checkAll(event) {
      let status = event.srcElement.checked;
      if(status === true) {
        this.outPutUsers = this.selectedUsers;
      } else {
        this.outPutUsers = [];
      }
    },
    /* 확인 버튼 클릭 시 */
    returnOrgParams() {   
      if(this.selectedUsers.length !== 0) {
        if(this.modalInfo.mode == "ROLE_USER"){
          let obj = this;            
            EventBus.$emit("returnUser", {
              modalObj: this,
              depts: this.selectedDepts,
              users: this.selectedUsers,
              orgType: this.modalInfo.orgType,
            });
            setTimeout(() => {
                obj.$emit('close');
            })
        } else if(this.modalInfo.mode == "ORG_PAPER_DEPT_USER"){
            let obj = this;
            EventBus.$emit("returnDeptUser", {
              modalObj: this,
              depts: this.selectedDepts,
              users: this.selectedUsers,
              orgType: this.modalInfo.orgType,
            });
            setTimeout(() => {
                obj.$emit('close');
            })
        }else if(this.modalInfo.orgType == "MULTI_ORG_BOARD"){
          this.$emit("dialogConfirm", {
          modalObj: this,
          depts: this.selectedDepts,
          users: this.selectedUsers,
          orgType: this.modalInfo.orgType,
          paperId: this.modalInfo.paperId,
          dialogType: "ORG_ADD_MEMBER"
          });
          this.$emit("close");
        } else {
          this.$emit("returnOrgParams", {
          modalObj: this,
          depts: this.selectedDepts,
          users: this.selectedUsers,
          orgType: this.modalInfo.orgType,
          });
          this.$emit("close");
        }
      } else {
        let info = {
            title: "알림",
            contents: this.$i18nUtil.trans("AB042"),
            button: "확인"
        };
        this.handleDialog(info);
      }
    },
    /* 알림 Dialog */
    handleDialog(info) {
        const dialogInfo = {
            obj: this.$modal,
            component: Dialog,
            title : info.title,
            button : info.button,
            contents : info.contents
        };
        this.showDialog(dialogInfo);
    },
    /* 취소 버튼 클릭 시 */
    handleClose() {
      this.setSelectedUsers(null);
      this.setSelectedDepts(null);
      this.resetTreeList(null);
      this.setTreeOfUserList(null);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
  .organization_wrap .btn-area .enCss::before {
    margin-right: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/cowork/common/organization/org/MultiOrg.vue